<template>
  <div class="block">
    <kst-number-with-date view-mode
      :catalog="Catalog"
      :data="details"
      dateField="Date"
      numberField="ReturnNumber"
    />
    
    <template v-if="details.ClientID">
      <kst-output field="ClientID" :data="details" :catalog="Catalog">
        <template #left>
          <kst-output addons floating-label
            field="ClientAlias" :data="details" :catalog="Catalog"
          />
        </template>
        <template #default>
          <kst-output addons expanded floating-label
            field="ClientName" :data="details" :catalog="Catalog"
          />
        </template>
      </kst-output>
    </template>
    <template v-else>
      <kst-output control-off field="ClientID" :data="details" :catalog="Catalog">
        <kst-output addons expanded floating-label
          field="ClientName" :data="details" :catalog="Catalog"
        />
      </kst-output>
    </template>

    <kst-output field="ClientAddress" :data="details" :catalog="Catalog"/>
    <kst-output field="WarehouseID" :data="details" :catalog="Catalog"/>
    <kst-output field="Comment" :data="details" :catalog="Catalog"/>
    <kst-created :data="details"/>
    <kst-last-updated :data="details"/>
  </div>
</template>

<script>
import Catalog from "../RinvCatalog.js";

export default {
  props: {
    details: Object
  },
  data: () => ({
    Catalog: Catalog
  })
}
</script>